// extracted by mini-css-extract-plugin
export default {"separator":"ZJwFI","column":"xbbaq","dropdown":"kEZkq","placeholder":"mRVO7"};